import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { solicitarPersistencia } from './almacenamiento';
import './estilos/tokens.css';
import './estilos/base.css';

/**
 * Se pide persistencia al arrancar, no al instalar: Chrome concede el permiso
 * con más facilidad cuando la aplicación ya está instalada, y llamarlo en cada
 * arranque es idempotente y barato.
 */
void solicitarPersistencia();

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Falta el elemento #root en index.html');

createRoot(raiz).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
